"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flexDirectionValues = exports.ControlTag = void 0;
const General_1 = require("./General");
var ControlTag;
(function (ControlTag) {
    ControlTag["page"] = "page";
    ControlTag["switch"] = "switch";
    ControlTag["button"] = "button";
    ControlTag["topNavBar"] = "topNavBar";
    ControlTag["sideMenu"] = "sideMenu";
    ControlTag["bottomMenuSheet"] = "bottomMenuSheet";
    ControlTag["Swiper"] = "Swiper";
    ControlTag["View"] = "View";
    ControlTag["calendar"] = "calendar";
    ControlTag["camera"] = "camera";
    ControlTag["checkbox"] = "checkbox";
    ControlTag["datePicker"] = "datePicker";
    ControlTag["graphicView"] = "graphicView";
    ControlTag["icon"] = "icon";
    ControlTag["image"] = "image";
    ControlTag["sectionList"] = "sectionList";
    ControlTag["slider"] = "slider";
    ControlTag["text"] = "text";
    ControlTag["ionitem"] = "ionitem";
    ControlTag["videoView"] = "videoView";
    ControlTag["webView"] = "webView";
    ControlTag["map"] = "map";
    ControlTag["Picker"] = "Picker";
    ControlTag["radio"] = "radio";
    ControlTag["flatList"] = "flatList";
    ControlTag["video"] = "video";
    ControlTag["bannerAd"] = "bannerAd";
    ControlTag["jitsiMeet"] = "jitsiMeet";
    ControlTag["stripeCardField"] = "a";
})(ControlTag || (exports.ControlTag = ControlTag = {}));
exports.flexDirectionValues = ['row-reverse', 'row', 'column-reverse', 'column'];
